export default {
  /// <summary>
  /// Lỗi
  /// </summary>
  Fail: 0,

  /// <summary>
  /// Thành công
  /// </summary>
  Success: 1,

  /// <summary>
  /// Xác thực 2 lớp
  /// </summary>
  Twofactor: 2,

  /// <summary>
  /// Lỗi Runtime
  /// </summary>
  RuntimeError: -1,

  /// <summary>
  /// Không sử dụng lương
  /// </summary>
  FailNotSalary: -2,

  /// <summary>
  /// Không có quyền sử dụng lương
  /// </summary>
  FailNotAccessSalary: -3,

  /// <summary>
  /// Chưa đăng nhập
  /// </summary>
  Authen: -4,

  /// <summary>
  /// Mã API kết nối từ Bumas sang ko chính xác
  /// </summary>
  FailApiKey: -5,

  /// <summary>
  /// Hết hạn sử dụng phần mềm
  /// </summary>
  LicenseExpired: -6,

  /// <summary>
  ///
  /// </summary>
  ErrorException: 99,
};
